import UpdateItems from "../features/inventory/UpdateItems"

const UpdateInventoryItemPage = () => {
    return (
        <>
            <UpdateItems />
        </>
    )
}

export default UpdateInventoryItemPage